import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import Sport from './liveMenuSport';
import Counter from './liveMenuCounter';


@withRouter
@inject('lineStore')
@observer
class LiveMenuOther extends Component {
  getCount = () => {
    let count = 0;
    this.props.lineStore.menu.other.forEach(i => {
      const arrLeague = this.props.lineStore.menu.sport.get(i).league;
      for (const id of arrLeague) {
        if (this.props.lineStore.menu.league.has(id)) {
          count += this.props.lineStore.menu.league.get(id).games.length;
        }
      }
    });
    return count;
  }

  selectItem = () => {
    this.props.history.push(`/${this.props.lineStore.mode}/other`);
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(null, 5);
  }

  render() {
    const { other, isOpen } = this.props.lineStore.menu;

    if (!other || (other && other.length === 0)) {
      return null;
    }

    const isOpenedOther = isOpen.other;

    return (
      <div
        className="favourites-other-sport-item"
        title="Остальные"
      >
        <button
          className={`favourites-sport-item-toggle ${isOpenedOther ? 'f-i-t-a' : ''}`}
          onClick={this.toggle}
        >
          <div>
            <span className="f-s-ico-arrow_buttom_1" />
          </div>
        </button>
        <button
          className="favourites-item-load favourites-other-sport-item-toggle f-i-l s-g-other"
          onClick={this.selectItem}
        >
          <span className="line-sport-menu-item-ico f-s-ico-other" />
          <Counter count={this.getCount()} />
          <div className="favourites-item-load-label">Остальные</div>
        </button>
        {isOpenedOther && (
          <div className="line-other-menu-item-sport-list">
            {other.map(id => (
              <Sport
                key={id}
                id={id}
                type={1}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default LiveMenuOther;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuOther.jsx